import React, { useEffect, useRef } from "react";
import L from "leaflet";
import { addCourseLegend, addCourseMarkers } from "../utils/courseMarkers";

const DEFAULT_CENTER = [53.38, -1.47];

export default function Map({ points = [], start = null, finish = null }) {
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  const polylineRef = useRef(null);
  const courseLayerRef = useRef(null);
  const courseLegendRef = useRef(null);

  useEffect(() => {
    if (!mapRef.current || mapInstanceRef.current) return;
    const map = L.map(mapRef.current).setView(DEFAULT_CENTER, 13);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
    }).addTo(map);
    mapInstanceRef.current = map;
    return () => {
      if (courseLayerRef.current) {
        map.removeLayer(courseLayerRef.current);
        courseLayerRef.current = null;
      }
      if (courseLegendRef.current) {
        map.removeControl(courseLegendRef.current);
        courseLegendRef.current = null;
      }
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
      polylineRef.current = null;
    };
  }, []);

  useEffect(() => {
    const map = mapInstanceRef.current;
    if (!map) return;

    const bounds = [];

    if (polylineRef.current) {
      map.removeLayer(polylineRef.current);
      polylineRef.current = null;
    }

    const courseLatLngs = addCourseMarkers(map, { start, finish }, courseLayerRef);
    addCourseLegend(map, { start, finish }, courseLegendRef);
    courseLatLngs.forEach((ll) => bounds.push([ll.lat, ll.lng]));

    const latlngs = points.map((p) => [p.lat, p.lng]);
    latlngs.forEach((ll) => bounds.push(ll));

    if (latlngs.length === 1) {
      // keep single trail point in bounds; view handled below
    } else if (latlngs.length > 1) {
      const polyline = L.polyline(latlngs, { weight: 4 }).addTo(map);
      polylineRef.current = polyline;
    }

    if (bounds.length === 1) {
      map.setView(bounds[0], 15);
    } else if (bounds.length > 1) {
      map.fitBounds(bounds, { padding: [30, 30] });
    }
  }, [points, start, finish]);

  return <div ref={mapRef} style={{ height: "450px", borderRadius: "10px", marginBottom: "30px" }} />;
}
